import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import 'angular-bootstrap-checkbox';
import 'angular-moment/';

// Dependencies
import servicesModuleName from '../../../../../lib/service';
import geoServiceModule from '../../../../../lib/service/GeoService';
import errorListModule from '../../../../../lib/components/errorList';

// Translations
import translate from '../../../../../lib/translation';

// Controller
import EditPositionModalController from './editPositionModal.controller';
import template from './editPositionModal.html';

const moduleName = 'staff.dashboardScreen.editPositionModal';
let module = angular.module(moduleName, [
  servicesModuleName,
  datepickerPopup,
  datepicker,
  errorListModule.name,
  geoServiceModule.name,
  uiModal,
  'geolocation',
  translate,
  'ui.checkbox',
  'angularMoment',
]);

module.controller('EditPositionModalController', EditPositionModalController);

module.factory('editPositionModal', ['$uibModal', '$q', ($uibModal, $q, date) => {
  return props => {

    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: EditPositionModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        position: props.position,
        staffUser: props.staffUser
      }
    });
    return modal.result;
  };
}]);

/**
 * NOTE: We can probably remove this code; it's no longer used in editPositionModal.html. Rather, incoming datetimes
 * are converted to local browser time, and outgoing datetimes are sent in local browser time, and have timezone
 * information stripped by formatting.
 */
module.directive('datetimepickerNeutralTimezone', function () {
  return {
    restrict: 'A',
    priority: 1,
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$formatters.push(function (value) {
        let date = new Date(Date.parse(value));
        date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
        return date;
      });

      ctrl.$parsers.push(function (value) {
        let date = new Date(value.getTime() - (60000 * value.getTimezoneOffset()));
        return date;
      });
    }
  };
});

export default module;
